/**
 * DDI com 2 dígitos editáveis (padrão 55) + celular BR (DDD + 9 dígitos).
 * `react-input-mask`: `9` = dígito.
 */
export const BR_CELLPHONE_INPUT_MASK = "+99 (99) 9 9999 9999";

/**
 * Valor inicial: +55 visível, restante com placeholders da máscara (`_`).
 * O usuário pode apagar/alterar o "55" para outro DDI de 2 dígitos.
 */
export const BR_CELLPHONE_DEFAULT_MASKED_VALUE = "+55 (__) _ ____ ____";

const MASKED_COMPLETE_REGEX = /^\+(\d{2}) \(\d{2}\) \d \d{4} \d{4}$/;

export function digitsFromBrazilMaskedPhone(value: string): string {
  return value.replace(/\D/g, "");
}

export function isBrazilCellphoneMaskComplete(value: string): boolean {
  return MASKED_COMPLETE_REGEX.test(value);
}
